export default __webpack_public_path__ + "static/media/Cover-letter-writing-guide.1c1f4f96.pdf";